/**
 * CRM 파이프라인 보드 레이아웃 (C5 · B-3 §9.2): 900–1199px 가로 스크롤 그림자
 * (ov-l/ov-r), ≤900px 단계 탭 스트립 + 한 열 + 스와이프 + 카드 long-press 컨텍스트
 * 메뉴. 보드는 이제 열린 단계만 그리므로 수주/실주 세로 레일과 그 펼침/접기
 * 상태(localStorage crm.board.open.<stage>)는 없다 — 종결은 요약 스트립이 맡는다.
 * crm.js 가 setupBoardLayout(board, ctx) 로 붙이고 syncColumnMeta 로 건수·합계를 맞춘다.
 */

const TAB_KEY = 'crm.board.tab';

function lsGet(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
function lsSet(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (_) { /* */ } }

/** Column header count/total and mobile tab counts from the live cards. */
export function syncColumnMeta(board, money) {
    if (!board) return;
    const tabs = document.getElementById('crmBoardTabs');
    board.querySelectorAll('.kb-col').forEach((col) => {
        const cards = col.querySelectorAll('.kb-card');
        let total = 0; cards.forEach((c) => { total += Number(c.dataset.amount) || 0; });
        const n = cards.length;
        col.dataset.count = String(n); col.dataset.total = String(total);
        const cnt = col.querySelector('.kb-col-count'); if (cnt) cnt.textContent = n;
        const tot = col.querySelector('.kb-col-total'); if (tot) { tot.textContent = money(total); tot.hidden = n === 0; }
        const empty = col.querySelector('.kb-empty-add');
        if (n === 0 && !empty && !col.querySelector('.kb-quick')) {
            const b = document.createElement('button'); b.type = 'button'; b.className = 'kb-empty-add'; b.dataset.act = 'quick';
            const add = col.querySelector('.kb-add'); b.textContent = add ? add.textContent : '＋';
            col.querySelector('.kb-cards').appendChild(b);
        } else if (n > 0 && empty) empty.remove();
        if (tabs) { const t = tabs.querySelector('[data-stage="' + col.dataset.stage + '"] b'); if (t) t.textContent = n; }
    });
}

export function setupBoardLayout(board, ctx) {
    if (!board) return null;
    const tabs = document.getElementById('crmBoardTabs');
    const isDesktop = () => window.matchMedia('(min-width: 1200px)').matches;
    const isPhone = () => window.matchMedia('(max-width: 900px)').matches;

    // ── 900–1199: 오버플로 그림자 ──
    function syncShadow() {
        if (isDesktop() || isPhone()) { board.classList.remove('ov-l', 'ov-r'); return; }
        const max = board.scrollWidth - board.clientWidth;
        board.classList.toggle('ov-l', board.scrollLeft > 2);
        board.classList.toggle('ov-r', max - board.scrollLeft > 2);
    }
    board.addEventListener('scroll', syncShadow, { passive: true });
    const sig = ctx.signal;
    window.addEventListener('resize', syncShadow, { signal: sig });

    // ── ≤900: 단계 탭 + 한 열 + 스와이프 ──
    const stageKeys = () => Array.from(board.querySelectorAll('.kb-col')).map((c) => c.dataset.stage);
    function setTab(stage, persist) {
        board.querySelectorAll('.kb-col').forEach((c) => c.classList.toggle('active', c.dataset.stage === stage));
        if (tabs) tabs.querySelectorAll('.att-seg-btn').forEach((b) => { b.classList.toggle('active', b.dataset.stage === stage); b.setAttribute('aria-selected', b.dataset.stage === stage ? 'true' : 'false'); });
        if (persist) lsSet(TAB_KEY, stage);
        if (tabs) { const b = tabs.querySelector('.att-seg-btn.active'); if (b && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center' }); }
    }
    function applyTab() {
        const keys = stageKeys();
        let cur = lsGet(TAB_KEY);
        if (!keys.includes(cur)) cur = keys[0] || '';
        setTab(cur, false);
    }
    function activeStage() { const c = board.querySelector('.kb-col.active'); return c ? c.dataset.stage : ''; }
    function stepTab(dir) {
        const keys = stageKeys(); const i = keys.indexOf(activeStage());
        const next = keys[i + dir]; if (next) setTab(next, true);
    }
    document.addEventListener('click', (e) => {
        const b = e.target.closest('#crmBoardTabs .att-seg-btn'); if (!b) return;
        e.preventDefault(); setTab(b.dataset.stage, true);
    }, { signal: sig });
    let tx = 0, ty = 0, swiping = false;
    board.addEventListener('touchstart', (e) => { if (!isPhone() || e.touches.length !== 1) return; tx = e.touches[0].clientX; ty = e.touches[0].clientY; swiping = true; }, { passive: true });
    board.addEventListener('touchend', (e) => {
        if (!swiping) return; swiping = false;
        const t = e.changedTouches[0]; const dx = t.clientX - tx, dy = t.clientY - ty;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) stepTab(dx < 0 ? 1 : -1);
    }, { passive: true });
    // long-press 400ms → 컨텍스트 메뉴 (터치)
    let pressTimer = 0, pressCard = null, px = 0, py = 0;
    board.addEventListener('touchstart', (e) => {
        const card = e.target.closest('.kb-card'); if (!card || e.touches.length !== 1) return;
        pressCard = card; const t = e.touches[0]; px = t.clientX; py = t.clientY;
        clearTimeout(pressTimer);
        pressTimer = setTimeout(() => { if (pressCard === card && ctx.dealMenu) { ctx.dealMenu(px, py, card); pressCard = null; } }, 400);
    }, { passive: true });
    // 스크롤 중(8px 이상 이동)에는 취소 (C7)
    board.addEventListener('touchmove', (e) => { if (!pressCard) return; const t = e.touches[0]; if (Math.abs(t.clientX - px) > 8 || Math.abs(t.clientY - py) > 8) { clearTimeout(pressTimer); pressCard = null; } }, { passive: true });
    ['touchend', 'touchcancel'].forEach((ev) => board.addEventListener(ev, () => { clearTimeout(pressTimer); pressCard = null; }, { passive: true }));

    function applyAll() { applyTab(); syncShadow(); syncColumnMeta(board, ctx.money); }
    applyAll();
    document.addEventListener('calendar:refreshed', applyAll, { signal: sig });
    window.addEventListener('resize', () => { if (isPhone()) applyTab(); }, { signal: sig });
    return { setTab, stepTab, activeStage, isDesktop, isPhone, sync: applyAll };
}
